let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gpbn0")).then(() => parcelRequire('kXVNP'));